import queryString from 'query-string';
import urls from './urls';
import axios from 'axios';

class PublicLiveStreamsApi {
  /**
   *
   * @param {*} params should be { userName, memberType, placesId, placeType }
   */
  getPublicLiveStreams(params) {
    // this.restClient = new RestClient();

    const endpoint = `${urls.GET_LIST_PUBLIC_LIVE_STREAMS}?${queryString.stringify(params, { arrayFormat: 'comma' })}`;
    // return this.restClient.execute(endpoint, ApiMethod.GET);
    return axios.get(endpoint, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  /**
   *
   * @param params should be
   *           const params = {
            "name": utils.generateLiveStreamName() + "-" + this.props.loginReducer.userInfo.displayName,
            "imageUrl": imageThumbUrl,
            "user": {
              "userId": this.props.loginReducer.userInfo.xmppId,
              "userName": this.props.loginReducer.userInfo.displayName,
              "ageTitle": this.props.loginReducer.userInfo.ageTitle,
              "memberType": this.props.loginReducer.userInfo.memberTypeTitle.abbr,
              "location": this.props.loginReducer.userInfo.location,
              "fullAvatarUrl": this.props.loginReducer.userInfo.avatarUrl
            }
          };
   */
  createPublicLiveStream(params) {
    // this.restClient = new RestClient();
    // return this.restClient.execute(urls.CREATE_PUBLIC_LIVE_STREAM, ApiMethod.POST, params).then(res => {
    //   return res;
    // });
    const url = urls.CREATE_PUBLIC_LIVE_STREAM;
    return axios.post(url, params, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }
}

export default new PublicLiveStreamsApi();
